export enum OTP_TYPES {
    SMS = "phone",
    EMAIL = "email"
}